import { Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import styles from 'utils/youtube.css';

const YoutubeLazyLoadEmbedStyles = withStyles(styles)(Fragment);

export default YoutubeLazyLoadEmbedStyles;
